export enum PRODUCT_AREA {
  HOME_PAGE = "Home Page",
}

export enum PAGE_NAME {
  HOME_PAGE = "Home Page",
}

export enum PAGE_AREA {
  SITES_LIST = "Sites List",
}

export const CHOOSE_DESIGN_PARTNER_BUTTON_NAME = "Choose Design Partner";